import React from "react";
import { Container, Form, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import LoginNavbar from "../Navbar/Navbar";
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Loader } from "rsuite";
import Footer from "../Footer/Footer";
function Login() {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userx = useSelector(state => state.user);

    const [loading, setLoading] = useState(false);
    const [tfaForm, setTfaForm] = useState(false);
    const [tfaToken, setTfaToken] = useState(null);
    const [tfaLoading, setTfaLoading] = useState(false);
    const [tfaCode, setTfaCode] = useState("");
    const [form, setForm] = useState({
        login: "",
        password: ""
    })
    const [validation, setValidation] = useState({
        login: null,
        password: null,
        auth: null,
        code : null
    })
    const [tfaValidation, setTfaValidation] = useState({
        code: null
    })
    const SignIn = async () => {

        if (loading) {
            return;
        }

        var initValidation = {
            login: null,
            password: null,
            auth: null
        }

        var errored = false;

        if (form.login === "") {
            initValidation.login = "Login must not be empty.";
            errored = true;
        }
        if (form.password === "") {
            initValidation.password = "Password must not be empty.";
            errored = true;
        }

        setValidation(initValidation);

        if (errored) {
            return;
        }

        setLoading(true);

        const response = await axios.post(window.__CFG.API + "manager/SignIn", form);

        if (response.data.Error == null) {
            if (response.data.TFA == 1) {
                toast.success("Two-Factor Authentication Required.", {
                    duration: 4000
                });
                setTfaForm(true);
                setTfaToken(response.data.TFAAuth);
                setLoading(false);
            } else {
                toast.success("Signed in successfully, redirecting...", {
                    duration: 4000
                });
                localStorage.setItem("raff-token", response.data.Token);

                const userResponse = await axios.get(window.__CFG.API + "manager/GetUser", {
                    headers: {
                        "Authorization": "Bearer " + response.data.Token
                    }
                })

                setLoading(false);

                if (userResponse.data.Error == null) {
                    dispatch({
                        type: "SET_USER",
                        data: {
                            logged: true,
                            user: userResponse.data.User
                        }
                    })
                    navigate("/dashboard");
                }
            }
        }
        else {
            setLoading(false);

            initValidation.auth = "Login or Password is invalid"
            toast.error(response.data.Error, {
                duration: 4000
            });
        }
    }

    const SignInTFA = async () => {
        if(tfaCode == "") {
            toast.error("Two-Factor Authentication code cannot be empty.", {
                duration : 4000
            })
            return ;
        }

        setTfaValidation({
            code : null
        })

        setTfaLoading(true);

        const response = await axios.post(window.__CFG.API + "manager/AuthenticateTFA", {
            code : tfaCode,
            token : tfaToken
        })

        setTfaLoading(false);

        if(response.data.Error == null) {
            toast.success("Signed in successfully, redirecting...", {
                duration: 4000
            });
            localStorage.setItem("raff-token", response.data.Token);

            const userResponse = await axios.get(window.__CFG.API + "manager/GetUser", {
                headers: {
                    "Authorization": "Bearer " + response.data.Token
                }
            })

            if (userResponse.data.Error == null) {
                dispatch({
                    type: "SET_USER",
                    data: {
                        logged: true,
                        user: userResponse.data.User
                    }
                })
                navigate("/dashboard");
            }
        } else {
            toast.error("Incorrect Two-Factor Authentication Code.", {
                duration: 4000
            });
        }
    }

    return (
        <>
            <div style={{ maxHeight: "90vh", overflowY: "hidden" }} >
                <div>
                    <LoginNavbar />
                </div>
                <div>
                    <Container fluid className="d-flex justify-content-center mt-5 vh-100">
                        <div className="w-20" style={{ marginTop: 20 }}>
                            {
                                tfaToken !== null ? (
                                    <>
                                        <Form style={{ width: 250 }}>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <input
                                                    type="text"
                                                    placeholder="Two-Factor Authentication Code"
                                                    style={{
                                                        borderRadius: "0",
                                                        outline: "none",
                                                        border: "1px solid grey",
                                                        boxShadow: "none",
                                                        marginBottom: "0rem",
                                                        fontFamily: "sans-serif",
                                                        height: 30,
                                                        fontSize: 14,
                                                        width: "100%"
                                                    }}
                                                    onChange={e => setTfaCode(e.target.value)}
                                                    value={tfaCode}
                                                    className={'form-control ' + (validation.login !== null ? "is-invalid" : "")}
                                                />
                                                {
                                                    validation.code !== null ? (
                                                        <div class="invalid-feedback loginForm">
                                                            {validation.code}
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </Form.Group>

                                            <Button
                                                onClick={() => SignInTFA()}
                                                className="w-100"
                                                style={{
                                                    backgroundColor: "#7eac2f",
                                                    color: "#FFF",
                                                    border: "none",
                                                    borderRadius: "0",
                                                    padding: "0.2rem",
                                                    fontWeight: 500,
                                                    fontSize: 15
                                                }}
                                                disabled={tfaLoading}
                                            >
                                                {
                                                    tfaLoading ? (
                                                        <><Loader size="xs" /></>
                                                    ) : (
                                                        <>Verify</>
                                                    )
                                                }
                                            </Button>
                                            {
                                                validation.auth !== null ? (
                                                    <div style={{ textAlign: "center" }} class="invalid-feedback loginForm">
                                                        {validation.auth}
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }                                <div className="text-center mt-3">
                                                <NavLink
                                                    onClick={() => setTfaToken(null)}
                                                    className="text-decoration-none "
                                                    style={{ fontWeight: "600", color: "#095fa1", backgroundColor : "#7eac2f" }}
                                                >
                                                    Sign In
                                                </NavLink>
                                            </div>
                                        </Form>
                                    </>
                                ) : (
                                    <Form style={{ width: 250 }}>
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <input
                                                type="text"
                                                placeholder="Enter Username"
                                                style={{
                                                    borderRadius: "0",
                                                    outline: "none",
                                                    border: "1px solid grey",
                                                    boxShadow: "none",
                                                    marginBottom: "0rem",
                                                    fontFamily: "sans-serif",
                                                    height: 30,
                                                    fontSize: 14,
                                                    width: "100%"
                                                }}
                                                onChange={e => setForm({ ...form, login: e.target.value })}
                                                value={form.login}
                                                className={'form-control ' + (validation.login !== null ? "is-invalid" : "")}
                                            />
                                            {
                                                validation.login !== null ? (
                                                    <div class="invalid-feedback loginForm">
                                                        {validation.login}
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <input
                                                type="password"
                                                placeholder="Password"
                                                style={{
                                                    borderRadius: "0",
                                                    outline: "none",
                                                    border: "1px solid grey",
                                                    boxShadow: "none",
                                                    marginBottom: "0rem",
                                                    fontFamily: "sans-serif",
                                                    height: 30,
                                                    fontSize: 14,
                                                    width: "100%"

                                                }}
                                                onChange={e => setForm({ ...form, password: e.target.value })}
                                                value={form.password}
                                                className={'form-control ' + (validation.password !== null ? "is-invalid" : "")}
                                            />
                                            {
                                                validation.password !== null ? (
                                                    <div class="invalid-feedback loginForm">
                                                        {validation.password}
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </Form.Group>

                                        <Button
                                            onClick={() => SignIn()}
                                            className="w-100"
                                            style={{
                                                backgroundColor: "#7eac2f",
                                                color: "#FFF",
                                                border: "none",
                                                borderRadius: "0",
                                                padding: "0.2rem",
                                                fontWeight: 500,
                                                fontSize: 15
                                            }}
                                            disabled={loading}
                                        >
                                            {
                                                loading ? (
                                                    <><Loader size="xs" /></>
                                                ) : (
                                                    <>Sign in</>
                                                )
                                            }
                                        </Button>
                                        {
                                            validation.auth !== null ? (
                                                <div style={{ textAlign: "center" }} class="invalid-feedback loginForm">
                                                    {validation.auth}
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }                                <div className="text-center mt-3">
                                            <NavLink
                                                to="/forgetpassword"
                                                className="text-decoration-none "
                                                style={{ fontWeight: "600", color: "#095fa1" }}
                                            >
                                                Forgotten password?
                                            </NavLink>
                                        </div>
                                    </Form>
                                )
                            }
                        </div>
                    </Container>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Login;
